import { useAppServices } from "hook/services";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { useState } from "react";

import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import AccounTab from "./components/Tabs/AccountTab";
import ContactTab from "./components/Tabs/ContactTab";
import Links from "./components/Tabs/Links";
import Attachments from "./components/Tabs/Attachments";
import SocialUrl from "./components/Tabs/SocialUrl";
import BusinessCustomCodeTab from "./components/Tabs/BusinessCustomCodeTab";
import Reviews from "./components/Tabs/Reviews";
import BusinessHours from "./components/Tabs/BusinessHours";
import Blogs from "./components/Tabs/Blogs";
import Team from "./components/Tabs/Team";
import NewsFeed from "./components/Tabs/NewsFeed";
import Analaytics from "./components/Tabs/Analaytics";
import JobsTab from "./components/Tabs/JobsTab";
import Events from "./components/Tabs/Events";
import CustomTabs from "../components/CustomTabs";
import PageTitle from "../components/PageTitle";
import GoogleImages from "./components/Tabs/GoogleImages";
import { useAgencyInfo } from "context/agency";
import "./components/Tabs/accountDetailTabs.css";
import Deals from "./components/Tabs/Deals";

function AccountDetail() {
  const navigate = useNavigate();
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const [formData, setformData] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const onLoad = async () => {
    const url = window.location.href;
    const parts = url.split("/"); // Split the URL by '/'
    const lastPart = parts[parts.length - 1]; // Get the last part of the URL
    const { response } = await AppService.accounts.getbyid({
      query: `id=${lastPart}&agency_id=${agency?._id}`,
    });
    const accountData = response?.data ?? response;
    if (accountData) {
      setformData(accountData);
    }
  };
  useEffect(() => {
    if (!agency?._id) return;
    onLoad();
  }, [agency?._id]);

  const businessHourFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Business Hour Configurations"
  );
  const TeamsFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Teams"
  );
  const AttachmentFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Featured Image"
  );
   const blogsFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Blogs"
  );
  const eventsFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Events"
  );
  const jobsFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Jobs"
  );
  const newsFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "News Feeds"
  );

  const ExtraLinkFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Extra Links"
  );

  const SocialMediaFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Social Media"
  );

  const customCodeEmbedFeature = formData?.plan?.features?.find(
    (feature) =>
      typeof feature?.name === "string" &&
      feature.name.trim().toLowerCase() === "custom code embed"
  );

   const ReviewsFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Reviews"
  );
  const DealsFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Deals"
  );

  let tabsData = [
    { label: "Analytics", content: <Analaytics handleRefresh={onLoad} formData={formData} /> },
    { label: "Account Owner", content: <AccounTab handleRefresh={onLoad} formData={formData} /> },
    {
      label: "Business details",
      content: <ContactTab handleRefresh={onLoad} formData={formData} />,
    },
  ];

  if(blogsFeature?.value){
       tabsData.push(
        { label: "Blogs", content: <Blogs handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(eventsFeature?.value){
       tabsData.push(
         { label: "Events", content: <Events handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(jobsFeature?.value){
       tabsData.push(
         { label: "Jobs", content: <JobsTab handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(newsFeature?.value){
       tabsData.push(
         { label: "News Feed", content: <NewsFeed handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(ReviewsFeature?.value){
       tabsData.push(
        { label: "Reviews", content: <Reviews handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(businessHourFeature?.value){
       tabsData.push(
        {
      label: "Business Hours",
      content: <BusinessHours handleRefresh={onLoad} formData={formData} />,
    },
       )
  }
  if(DealsFeature?.value){
       tabsData.push(
        { label: "Deals", content: <Deals handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(TeamsFeature?.value){
       tabsData.push(
        { label: "Team", content: <Team handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(AttachmentFeature?.value){
       tabsData.push(
        { label: "Additional Images", content: <Attachments handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(ExtraLinkFeature?.value){
       tabsData.push(
        { label: "Links", content: <Links handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(SocialMediaFeature?.value){
       tabsData.push(
        { label: "Social Urls", content: <SocialUrl handleRefresh={onLoad} formData={formData} /> },
       )
  }
  // Premium listings: show unless the SaaS plan explicitly turns this feature off (value === false).
  const showCustomCodeTab =
    formData?.plan_type === "premium" && customCodeEmbedFeature?.value !== false;
  if (showCustomCodeTab) {
    tabsData.push({
      label: "Custom Code",
      content: <BusinessCustomCodeTab handleRefresh={onLoad} formData={formData} />,
    });
  }
  return (
    <PageLayout>
      <SoftBox alignItems="center" className="sd-account-detail sd-page">
            <div className="sd-page__header">
            <PageTitle>Business</PageTitle>
            <span
              className="sd-account-detail__breadcrumb"
              style={{ fontSize: "14px", cursor: "pointer" }}
              onClick={() => navigate(-1)}
            >
              {" "}
              {"Business"} {`>`}
            </span>{" "}
            <span className="sd-account-detail__breadcrumb" style={{ fontSize: "14px" }}>
              {" "}
              {formData?.first_name}
            </span>
            <PageTitle detail className="my-3percent">
              {formData?.first_name}{" "}
              <span className="alert-success-new">
                {formData?.plan_type === "premium" ? formData?.plan_type : "Free"}
              </span>
            </PageTitle>
            </div>
            <CustomTabs tabsData={tabsData} activeTab={activeTab} setActiveTab={setActiveTab} />
      </SoftBox>
    </PageLayout>
  );
}

export default AccountDetail;
